import {
    Field,
    FormikProps
} from 'formik';
import {
    FormikRadioCardGroup,
    FormikTextInput,
    PlatformFieldset
} from "@flexinet/ui-components";
import {OrganizationsAutocomplete} from "../../organizations/inputs/OrganizationsAutocomplete.tsx";
import {Account} from "../types.ts";


export const FormComponent = (props: FormikProps<Account>) => {


    return (
        <>
            <PlatformFieldset legend={'Account Details'}>

                <Field
                    name='name'
                    label='Account Name'
                    description='Please give the account name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />
                {/*<Field*/}
                {/*    name='email'*/}
                {/*    label='Root User Email'*/}
                {/*    description='Please select user email'*/}
                {/*    component={UserEmailsAutocomplete}*/}
                {/*    disabled={editing}*/}
                {/*    withAsterisk*/}
                {/*    my={'xl'}*/}
                {/*/>*/}

            </PlatformFieldset>

            <PlatformFieldset legend={'Account Type'}>

                <Field
                    name='accountType'
                    data={[{
                        label: 'STANDALONE',
                        description: 'This account is a standalone account and does not have any organization',
                        value: 'STANDALONE'
                    }, {
                        label: 'ROOT',
                        description: 'This account is a root account and is used by an organization as org admin account',
                        value: 'ROOT'
                    }, {
                        label: 'MANAGED',
                        description: 'This account is a managed account and has an organization',
                        value: 'MANAGED'
                    }]}
                    component={FormikRadioCardGroup}
                    withAsterisk
                    my={'xl'}
                />

                {props.values.accountType === 'MANAGED' &&
                    <Field
                        name='organizationId'
                        label='Organization'
                        description='Please select organization'
                        component={OrganizationsAutocomplete}
                        my={'xl'}
                    />}


            </PlatformFieldset>

            <PlatformFieldset legend={'Status'}>

                <Field
                    name='status'
                    data={[{
                        label: 'ACTIVE',
                        value: 'ACTIVE'
                    }, {
                        label: 'SUSPENDED',
                        value: 'SUSPENDED'
                    }]}
                    component={FormikRadioCardGroup}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>
        </>
    );
};
